import type { TFunction } from "i18next";
import type { FusionMenuConfig } from "~/components/dock/FusionMenu";

import { ApplicationEnum } from "~/@types/enums";

const createReportsFusionConfig = (t: TFunction<"common">): FusionMenuConfig => ({
	defaultQuickActionKeys: ["/reports/builder", "/reports/templates"],
	logo: "/logos/report.svg",
	module: ApplicationEnum.REPORTS,
	quickActions: [
		{ icon: "add", label: t("dock.quickActionLabels.reports.newReport"), path: "/reports/builder" },
		{ icon: "menu_book", label: t("dock.quickActionLabels.reports.browseTemplates"), path: "/reports/templates" }
	],
	sections: [
		{
			groups: [{ items: [{ icon: "assessment", label: t("dock.pages.reports.allReports"), path: "/reports" }] }],
			icon: "assessment",
			id: "all-reports",
			label: t("dock.pages.reports.allReports")
		},
		{
			groups: [
				{ items: [{ icon: "menu_book", label: t("dock.pages.reports.templates"), path: "/reports/templates" }] }
			],
			icon: "menu_book",
			id: "templates",
			label: t("dock.pages.reports.templates")
		},
		{
			groups: [
				{
					items: [
						{
							icon: "schedule",
							label: t("dock.pages.reports.schedules"),
							matchPaths: ["/reports/:reportId/schedules"],
							path: "/reports/schedules"
						}
					]
				}
			],
			icon: "schedule",
			id: "schedules",
			label: t("dock.pages.reports.schedules")
		},
		{
			groups: [
				{
					items: [
						{
							icon: "history",
							label: t("dock.pages.reports.executionHistory"),
							matchPaths: ["/reports/:reportId/executions"],
							path: "/reports/executions"
						}
					]
				}
			],
			icon: "history",
			id: "executions",
			label: t("dock.pages.reports.executionHistory")
		},
		{
			groups: [
				{ items: [{ icon: "mail", label: t("dock.pages.reports.orderEmails"), path: "/reports/order-emails" }] }
			],
			icon: "mail",
			id: "order-emails",
			label: t("dock.pages.reports.orderEmails")
		}
	]
});

export default createReportsFusionConfig;
